<div class="mb-5">
    <h5>Dados do responsável legal</h5>
    <div class="form-group" *ngIf="!ehEstrangeiro">
        <label class="required" for="cpf">{{ "Cpf" | localize }}</label>
        <input autocomplete="off" autocomplete="off" type="text" class="form-control" name="cpfResponsavelLegal"
            id="cpfResponsavelLegal" placeholder="{{ 'Cpf' | localize }}" maxlength="14" mask="000.000.000-00"
            [(ngModel)]="model.responsavelLegalCpf" #cpfResponsavelLegalModel="ngModel" #cpfResponsavelLegalEl
            (blur)="cpfResponsavelLegalChange(model.responsavelLegalCpf)" />
        <abp-validation-summary [control]="cpfResponsavelLegalModel"
            [controlEl]="cpfResponsavelLegalEl"></abp-validation-summary>
    </div>

    <div class="form-group" *ngIf="ehEstrangeiro">
        <label class="required" for="numeroPassaporte">Número do passaporte</label>
        <input autocomplete="off" type="text" class="form-control" id="numeroPassaporte" name="numeroPassaporte"
            placeholder="Digite o número do passaporte" [(ngModel)]="model.responsavelLegalNumeroPassaporte"
            (blur)="cpfResponsavelLegalChange(model.responsavelLegalNumeroPassaporte)" />
    </div>

    <div>
        <div class="form-group">
            <label class="required" for="Nome do responsável legal">{{ "Nome do responsável legal" | localize }}</label>
            <input required type="text" class="form-control" name="nomeResponsavelLegal" id="nomeResponsavelLegal"
                [(ngModel)]="model.responsavelLegalNome" #nomeResponsavelLegalModel="ngModel" #nomeResponsavelLegalEl
                maxlength="64" placeholder="Nome do responsável legal" />

            <abp-validation-summary [control]="nomeResponsavelLegalModel"
                [controlEl]="nomeResponsavelLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label for="Nome social do responsável legal">{{ "Nome social do responsável legal" | localize }}</label>
            <input type="text" class="form-control" name="nomeResponsavelLegal" id="nomeResponsavelLegal"
                [(ngModel)]="model.responsavelLegalNomeSocial" #nomeSocialResponsavelLegalModel="ngModel"
                #nomeSocialResponsavelLegalEl [ngModelOptions]="{ standalone: true }"
                placeholder="Nome social do responsável legal" />
            <abp-validation-summary [control]="nomeSocialResponsavelLegalModel"
                [controlEl]="nomeSocialResponsavelLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label for="Nome da mãe responsável legal">{{ "Nome da mãe responsável legal" | localize }}</label>
            <input type="text" class="form-control" name="nomeMaeResponsavelLegal" id="nomeMaeResponsavelLegal"
                [(ngModel)]="model.responsavelLegalNomeMae" #nomeMaeResponsavelLegallLegalModel="ngModel"
                #nomeMaeResponsavelLegalLegalEl [ngModelOptions]="{ standalone: true }"
                placeholder="Nome da mãe responsável legal" />
            <abp-validation-summary [control]="nomeMaeResponsavelLegallLegalModel"
                [controlEl]="nomeMaeResponsavelLegalLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label for="Religião do responsável legal">{{ "Religião do responsável legal" | localize }}</label>
            <input type="text" class="form-control" name="religiaoResponsavelLegal" id="religiaoResponsavelLegal"
                [(ngModel)]="model.responsavelLegalReligiao" #religiaoResponsavelLegalModel="ngModel"
                #religiaoResponsavelLegalEl [ngModelOptions]="{ standalone: true }"
                placeholder="Religião do responsável legal" />
            <abp-validation-summary [control]="religiaoResponsavelLegalModel"
                [controlEl]="religiaoResponsavelLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label for="Profissão do responsável legal">{{ "Profissão do responsável legal" | localize }}</label>
            <input type="text" class="form-control" name="ProfissaoResponsavelLegal" id="ProfissaoResponsavelLegal"
                [(ngModel)]="model.responsavelLegalProfissao" #ProfissaoResponsavelLegallLegalModel="ngModel"
                #ProfissaoResponsavelLegalLegalEl [ngModelOptions]="{ standalone: true }"
                placeholder="Profissão do responsável legal" />
            <abp-validation-summary [control]="ProfissaoResponsavelLegallLegalModel"
                [controlEl]="ProfissaoResponsavelLegalLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label class="required" for="DataNascimento">{{ "DataNascimento" | localize }}</label>
            <input required id="dataNascimentoResposnsavel" type="text" class="form-control"
                name="dataNascimentoResposnsavel" placeholder="{{ 'DataNascimento' | localize }}" maxlength="10"
                mask="00/00/0000" [(ngModel)]="dataResponsavel" #dataNascimentoModel="ngModel" #dataNascimentoEl />
            <abp-validation-summary [control]="dataNascimentoModel" [controlEl]="dataNascimentoEl">
            </abp-validation-summary>
        </div>

        <div class="form-group">
            <label class="required" for="Celular do responsável legal">{{ "Celular do responsável legal" | localize
                }}</label>
            <input type="text" class="form-control" name="celularResponsavelLegal" id="celularResponsavelLegal"
                [(ngModel)]="model.responsavelLegalCelular" #celularResponsavelLegalModel="ngModel"
                #celularResponsavelLegalEl [required]="model.isDependente" mask="(00) 00000-0000"
                placeholder="Celular do responsável legal" />
            <abp-validation-summary [control]="celularResponsavelLegalModel"
                [controlEl]="celularResponsavelLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label class="required" for="Grau de parentesco">{{ "Grau de parentesco" | localize }}</label>
            <select class="custom-select kt-input select-with-placeholder" name="grauParentesco"
                [(ngModel)]="model.grauParentesco" [value]="undefined" #grauParentescoModel="ngModel" #grauParentescoEl
                [ngModelOptions]="{ standalone: true }">
                <option [value]="undefined" disabled selected class="option-placeholder">
                    Selecione o grau de parentesco
                </option>
                <option *ngFor="let parentesco of grausParentesco" [ngValue]="parentesco.value">
                    {{ parentesco.name }}
                </option>
            </select>
            <abp-validation-summary [control]="grauParentescoModel"
                [controlEl]="grauParentescoEl"></abp-validation-summary>
        </div>

        <div class="form-group">
            <label for="E-mail do responsável legal">{{ "E-mail do responsável legal" | localize }}</label>
            <input type="text" class="form-control" name="emailResponsavelLegal" id="emailResponsavelLegal"
                [(ngModel)]="model.responsavelLegalEmail" #emailResponsavelLegalModel="ngModel" #emailResponsavelLegalEl
                [ngModelOptions]="{ standalone: true }" placeholder="E-mail do responsável legal" />
            <abp-validation-summary [control]="emailResponsavelLegalModel"
                [controlEl]="emailResponsavelLegalEl"></abp-validation-summary>
        </div>

        <div class="form-group" *ngIf="requiredPasswordResponsavelLegal">
            <label class="required" for="Senha">{{ "Senha" | localize }}</label>
            <div class="input-group">
                <div class="input-group-append pass-posstion icon-div">
                    <div class="input-group-text p-4" style="
                  cursor: pointer;
                  padding-top: 0.9rem !important;
                  padding-bottom: 0.9rem !important;
                " (click)="visualizarSenha()">
                        <span class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
                    </div>
                </div>
                <input [type]="showPassword ? 'password' : 'text'" class="form-control" name="responsavelLegalPassword"
                    placeholder="{{ 'Password' | localize }}" [(ngModel)]="model.responsavelLegalSenha"
                    pattern="(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z!.@#$%^&*()]*$"
                    [required]="requiredPasswordResponsavelLegal" maxlength="32"
                    #responsavelLegalPasswordModel="ngModel" #responsavelLegalPasswordEl />
            </div>
            <abp-validation-summary [control]="responsavelLegalPasswordModel" [controlEl]="responsavelLegalPasswordEl"
                [customValidationErrors]="passwordValidationErrors"></abp-validation-summary>
        </div>
    </div>
</div>